module.exports = __webpack_public_path__ + "static/media/about5_.39113b26.webp";